const mockHeroes = [
  {
    id: "1",
    name: "Thor",
    description: "Thor God of Thunder. Son of Odin",
    tags: ["thunder", "god", "mjolnir"],
    image: "thor.png",
  },
  {
    id: "2",
    name: "Iron man",
    description: "His name is Tony Stark",
    tags: ["iron", "tony stark"],
    image: "iron-man.png",
  },
  {
    id: "3",
    name: "Captain America",
    description: "Captan America was frozen long time ago",
    tags: ["captain", "america", "steve rojars"],
    image: "captain-america.png",
  },
  {
    id: "4",
    name: "Hulk",
    description: "Hulk has got his power from radiation",
    tags: ["crush", "green", "strong"],
    image: "hulk.png",
  },
  {
    id: "5",
    name: "Spider Man",
    description:
      "Spider has bitten Peter Parker and then he got the super power",
    tags: ["spider", "peter parker"],
    image: "spider-man.png",
  },
  {
    id: "6",
    name: "Black Widow",
    description: "Black Widot has no superpower",
    tags: ["widow", "natasha", "woman"],
    image: "black-widow.png",
  },
];

export default mockHeroes;
